import { render, staticRenderFns } from "./ProgramOverview.vue?vue&type=template&id=4d877324"
import script from "./ProgramOverview.vue?vue&type=script&lang=js"
export * from "./ProgramOverview.vue?vue&type=script&lang=js"
import style0 from "./ProgramOverview.vue?vue&type=style&index=0&id=4d877324&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports